import { AppRoute } from "app";
import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { latestReachedCheckpointFlowPageAtom } from "atoms/latestReachedCheckpointFlowPageAtom";
import { sessionIdAtom } from "atoms/sessionId";
import { Checkpoint } from "types/Checkpoint";
import { replaceSessionInAppRoute } from "utils/routeHelper";
import { DigitalJourneyRoute } from "app/DigitalJourneyAppFlow/constants";

export const useCheckpointRedirect = (path: AppRoute | DigitalJourneyRoute) => {
  const navigate = useNavigate();
  const sessionId = useAtomValue(sessionIdAtom);
  const latestReachedCheckpointFlowPage = useAtomValue(latestReachedCheckpointFlowPageAtom);

  const flowCompleted = latestReachedCheckpointFlowPage?.checkpoint === Checkpoint.FLOW_COMPLETED;

  useEffect(() => {
    if (flowCompleted && path !== latestReachedCheckpointFlowPage.path) {
      navigate(replaceSessionInAppRoute(latestReachedCheckpointFlowPage.path, sessionId));
    }
  }, [flowCompleted, latestReachedCheckpointFlowPage, navigate, path, sessionId]);

  return { flowCompleted };
};
